import { render, staticRenderFns } from "./SettingProducts.vue?vue&type=template&id=0a852b36&scoped=true&"
import script from "./SettingProducts.vue?vue&type=script&lang=js&"
export * from "./SettingProducts.vue?vue&type=script&lang=js&"
import style0 from "./SettingProducts.vue?vue&type=style&index=0&id=0a852b36&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a852b36",
  null
  
)

export default component.exports